var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99388 20C3.44498 20 3 19.5523 3 19C3 18.4477 3.44498 18 3.99388 18H20.0061C20.555 18 21 18.4477 21 19C21 19.5523 20.555 20 20.0061 20H3.99388ZM3.99388 13C3.44498 13 3 12.5523 3 12C3 11.4477 3.44498 11 3.99388 11H20.0061C20.555 11 21 11.4477 21 12C21 12.5523 20.555 13 20.0061 13H3.99388ZM3.99388 6C3.44498 6 3 5.55228 3 5C3 4.44772 3.44498 4 3.99388 4H20.0061C20.555 4 21 4.44772 21 5C21 5.55228 20.555 6 20.0061 6H3.99388Z",
    fill: "currentColor"
  })));
};
export default SvgHamburgerMenu;